import React from 'react';

export default function KnaekSecondaryButtonNoPadding({className, title, ...props}) {

    return (
        <button {...props}  className={` btn btn-secondary radius-50 shadow ${className}`}>
            {title}
        </button>
    );
}
